import { useMemo } from "react";
import { filterProducts, findSelectedProduct, getProducts, resolvePdfUrl, useCatalog, withSelect } from "./catalog";
import { ProductView } from "./ProductView";
import { CarouselView } from "./CarouselView";
import { PdfFlipViewer } from "./PdfFlipViewer";

export function CatalogLeaf({ node, vars, onVarChange, onAction, globalDataStore, interactive = true }) {
  const catalog = useCatalog();
  const all = useMemo(() => getProducts(node, catalog, globalDataStore), [node, catalog, globalDataStore]);
  const run = (actions, ctx) => { if (interactive && onAction) onAction(actions, ctx); };

  if (node.type === "pdfViewer") {
    return <PdfFlipViewer url={resolvePdfUrl(node, all, vars, !interactive)} node={node} interactive={interactive} />;
  }

  if (node.type === "carousel") {
    return <CarouselView node={node} products={filterProducts(all, node, vars)} catalog={catalog} interactive={interactive}
      onSelect={p => run(withSelect(node, node.onClick), p)} />;
  }

  const full = node.productViewMode === "full";
  const products = full
    ? [findSelectedProduct(node, all, vars, !interactive || node.productFallbackFirst)].filter(Boolean)
    : filterProducts(all, node, vars);

  return <ProductView node={node} products={products} catalog={catalog} vars={vars} onVarChange={onVarChange} interactive={interactive}
    onSelect={(kind, p) => {
      if (kind === "more") run(node.productMoreActions || [], null);
      else if (kind === "cta") run(withSelect(node, node.productCtaActions), p);
      else if (!full) run(withSelect(node, node.onClick), p);
    }} />;
}
